export const COUNTRIES = [
  ['UA', 'Ukraine'], ['US', 'United States'], ['GB', 'United Kingdom'], ['DE', 'Germany'], ['ES', 'Spain'], ['IT', 'Italy'], ['NL', 'Netherlands'], ['PL', 'Poland'], ['FR', 'France'], ['CA', 'Canada'], ['AU', 'Australia'], ['BR', 'Brazil'], ['MX', 'Mexico'], ['RO', 'Romania'], ['CZ', 'Czechia']
] as const;

export const FACEBOOK_POSITION_GROUPS = [
  { label: 'Feeds', positions: [['feed', 'Feed'], ['marketplace', 'Marketplace'], ['biz_disco_feed', 'Business discovery feed'], ['profile_feed', 'Profile feed']] },
  { label: 'Stories & Reels', positions: [['story', 'Stories'], ['facebook_reels', 'Facebook Reels'], ['facebook_reels_overlay', 'Reels overlay']] },
  { label: 'In-stream ads', positions: [['instream_video', 'In-stream video']] },
  { label: 'Search results', positions: [['search', 'Search results']] },
  { label: 'Other', positions: [['notification', 'Notifications']] },
] as const;

export const PLATFORM_LABELS: Record<string, string> = { facebook: 'Facebook', instagram: 'Instagram', audience_network: 'Audience Network', messenger: 'Messenger', threads: 'Threads' };
